"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SounditiApi_1 = __importDefault(require("../SounditiApi"));

var Auth_1 = __importDefault(require("../Auth"));

var defaults_1 = __importDefault(require("../defaults"));

var errors_1 = require("../utils/errors");

var utils_1 = require("../utils/utils");
/**
 * Provides access to the campaigns analysis data
 * @class
 *
 * @param {DataLayerConfiguration} [host = defaults.host] the api host
 *
 * @category Metrics
 *
*/


var AnalysisAccess = function () {
  /**
   *
   * @param {DataLayerConfiguration} options
   * @param {host} [options.hosts = defaults] | An access token
   *
   */
  function AnalysisAccess(_a) {
    var _b = (_a === void 0 ? {} : _a).hosts,
        hosts = _b === void 0 ? defaults_1.default : _b;
    this._authRenewal = utils_1.tokenRenewal;
    this.auth = new Auth_1.default({
      auth_host: hosts.auth_host
    });
    this.token = this.auth.getToken() || '';
    this.api = new SounditiApi_1.default({
      token: this.token,
      hosts: hosts
    });
  }
  /**
   * Returns the campaign main audience summary
   *
   * @param {string} campaignId campaign uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<AudienceSummary>} The campaign Summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.campaignAudienceSummary = function (_a) {
    var campaignId = _a.campaignId,
        _b = _a.renew,
        renew = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_1;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getCampaingAudienceSummary(campaignId)];

          case 1:
            res = _c.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _c.sent();

            return [4
            /*yield*/
            , this.campaignAudienceSummary({
              campaignId: campaignId,
              renew: false
            })];

          case 5:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _c.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_1 = _c.sent();
            throw error_1;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the campaign raw summary
   *
   * @param {string} campaignId Campaign uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<AudienceSummary>} The campaign Summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.campaignAudienceRawSummary = function (_a) {
    var campaignId = _a.campaignId,
        _b = _a.renew,
        renew = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_2;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getCampaingAudienceSummary(campaignId)];

          case 1:
            res = _c.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _c.sent();

            return [4
            /*yield*/
            , this.campaignAudienceRawSummary({
              campaignId: campaignId,
              renew: false
            })];

          case 5:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _c.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_2 = _c.sent();
            throw error_2;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the campaign monthly summary
   *
   * @param {string} campaignId Campaign uuid
   * @param {string} year Year of the summary
   * @param {string} month Month of the summary
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<AudienceSummary>} The campaign Summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.campaignMonthlySummary = function (_a) {
    var campaignId = _a.campaignId,
        year = _a.year,
        month = _a.month,
        _b = _a.renew,
        renew = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_3;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getCampaignMonthlySummary(campaignId, year, month)];

          case 1:
            res = _c.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _c.sent();

            return [4
            /*yield*/
            , this.campaignMonthlySummary({
              campaignId: campaignId,
              year: year,
              month: month,
              renew: false
            })];

          case 5:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _c.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_3 = _c.sent();
            throw error_3;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the last 30 days campaign summary
   *
   * @param {string} campaignId Campaign uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<AudienceSummary>} The campaign Summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.campaign30daysSummary = function (_a) {
    var campaignId = _a.campaignId,
        _b = _a.renew,
        renew = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_4;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getCampaign30daysSummary(campaignId)];

          case 1:
            res = _c.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _c.sent();

            return [4
            /*yield*/
            , this.campaign30daysSummary({
              campaignId: campaignId,
              renew: false
            })];

          case 5:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _c.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_4 = _c.sent();
            throw error_4;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the last 30 days module summary
   *
   * @param {string} moduleId Module uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<AudienceSummary>} The campaign Summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.module30daysSummary = function (_a) {
    var moduleId = _a.moduleId,
        _b = _a.renew,
        renew = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_5;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getmodule30daysSummary(moduleId)];

          case 1:
            res = _c.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _c.sent();

            return [4
            /*yield*/
            , this.module30daysSummary({
              moduleId: moduleId,
              renew: false
            })];

          case 5:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _c.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_5 = _c.sent();
            throw error_5;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the module audience summary
   *
   * @param {string} moduleId Module uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleAudienceSummary>} The module summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.moduleAudienceSummary = function (_a) {
    var moduleId = _a.moduleId,
        _b = _a.renew,
        renew = _b === void 0 ? true : _b;
    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_6;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getModuleAudienceSummary(moduleId)];

          case 1:
            res = _c.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _c.sent(); // logger.debug('moduleSummary returned', { ...summary })

            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _c.sent();

            return [4
            /*yield*/
            , this.moduleAudienceSummary({
              moduleId: moduleId,
              renew: false
            })];

          case 5:
            summary = _c.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _c.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_6 = _c.sent();
            throw error_6;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the module emotion summary for an emotion
   *
   * @param {string} moduleId Module uuid
   * @param {string} interactionId Interaction id
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleEmotionSummary>} The module summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.moduleEmotionSummary = function (moduleId, interactionId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getModuleEmotionSummary(moduleId, interactionId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.moduleEmotionSummary(moduleId, interactionId, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_7 = _a.sent();
            throw error_7;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the module replies summaries
   *
   * @param {string} moduleId Module uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleRepliesSummary>} The module summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.moduleRepliesSummary = function (moduleId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_8;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getModuleRepliesSummary(moduleId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.moduleRepliesSummary(moduleId, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_8 = _a.sent();
            throw error_8;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // NIVO EMOTION DATA PARSING

  /**
   * Returns parsed response for ft-control Metrics Summary
   *
   * @param {ModuleEmotionSummary} emotionalSummaries
   * @param {object} interactions
   */


  AnalysisAccess.prototype.parseNivoEmotionalMetricsSummary = function (emotionalSummaries, interactions) {
    var engagements = {};
    var satisfactions = {};
    var interests = {};
    var keys = [];
    interactions.map(function (v, i) {
      keys.push(v.name);
      engagements[v.name] = Math.round(emotionalSummaries[i].engagement.global.positive);
      satisfactions[v.name] = Math.round(emotionalSummaries[i].satisfaction.global.positive);
      interests[v.name] = Math.round(emotionalSummaries[i].interes.global.positive);
    });
    engagements['type'] = 'Engagement';
    satisfactions['type'] = 'Satisfaction';
    interests['type'] = 'Interest';
    return {
      d: [engagements, satisfactions, interests],
      k: keys
    };
  };
  /**
   * Returns Emotional overview parsed for tf-control Emotional Overviews
   *
   * @param {ModuleEmotionSummary} moduleEmotionalSummary
   * @param {object} interactionInfo
   * @param {string} [interactionInfo.name = "No name"]
   * @param {number} [interactionInfo.duration = 50]
   * @param {number} [dataPoints=30] number of datapoints to returned, max = max_frames
   */


  AnalysisAccess.prototype.parseNivoEmotionalOverview = function (moduleEmotionalSummary, interactionInfo, dataPoints) {
    if (interactionInfo === void 0) {
      interactionInfo = {
        name: 'No name',
        duration: 50
      };
    }

    if (dataPoints === void 0) {
      dataPoints = 30;
    }

    var total_serie = moduleEmotionalSummary.total.serie;
    var engagement_serie = moduleEmotionalSummary.engagement.serie;
    var satisfaction_serie = moduleEmotionalSummary.satisfaction.serie;
    var interest_serie = moduleEmotionalSummary.interes.serie;
    var frames = total_serie.length;
    var step = Math.round(frames / dataPoints);
    var duration = interactionInfo.duration;
    var total_data = [];
    var engagement_data = [];
    var satisfaction_data = [];
    var interest_data = [];

    for (var index = 0; index <= dataPoints; index++) {
      var serie_idx = Math.round(index * step);

      if (serie_idx >= frames) {
        serie_idx = frames - 1;
      }

      total_data[index] = {
        x: (duration / dataPoints * index).toFixed(2) + "s",
        y: total_serie[serie_idx],
        engagement: engagement_serie[serie_idx],
        satisfaction: satisfaction_serie[serie_idx],
        interest: interest_serie[serie_idx]
      };
      engagement_data[index] = {
        x: (duration / dataPoints * index).toFixed(2) + "s",
        y: engagement_serie[serie_idx]
      };
      satisfaction_data[index] = {
        x: (duration / dataPoints * index).toFixed(2) + "s",
        y: satisfaction_serie[serie_idx]
      };
      interest_data[index] = {
        x: (duration / dataPoints * index).toFixed(2) + "s",
        y: interest_serie[serie_idx]
      };
    }

    return {
      total: {
        id: interactionInfo.name,
        data: total_data
      },
      engagement: {
        id: interactionInfo.name,
        data: engagement_data
      },
      satisfaction: {
        id: interactionInfo.name,
        data: satisfaction_data
      },
      interest: {
        id: interactionInfo.name,
        data: interest_data
      }
    };
  };
  /**
   * Returns Emotional peaks summary parsed for tf-control Emotional Overviews
   *
   * @param {object} emotionalSummaries
   * @param {object} interactionInfo
   */


  AnalysisAccess.prototype.parseNivoEmotionalpeaksSummary = function (emotionalSummaries, interactions) {
    var emotion_values = ['angry', 'disgust', 'scared', 'happy', 'sad', 'surprised'];
    var max_emotion = [];
    interactions.map(function (v, i) {
      var total_duration = v.duration;
      var frames = emotionalSummaries[i].engagement.serie.length;
      var emotions = emotion_values.map(function (e) {
        return {
          name: v.name,
          emotion: e,
          emotionValue: Math.round(100 * emotionalSummaries[i].raw[e].peak.peak).toFixed(2),
          time: (emotionalSummaries[i].raw[e].peak.peak_idx / frames * total_duration).toFixed(2),
          percent: emotionalSummaries[i].raw[e].peak.peak_percent_duration,
          duration: emotionalSummaries[i].raw[e].peak.peak_s_duration
        };
      });
      max_emotion.push(emotions.reduce(function (init, p) {
        return parseInt(p.emotionValue) > init.emotionValue ? p : init;
      }, {
        name: "",
        emotionValue: 0
      }));
    });
    return max_emotion;
  };
  /**
   * Parses a module data using type as flag
   * to extract the interactions in the same format.
   * @param {ModuleItem} moduleData
   *
   * @returns {InteractionInformation[]}
   */


  AnalysisAccess.prototype.parseModule = function (moduleData) {
    var type = moduleData.type;

    if (type === 'video') {
      return moduleData.videos;
    } else if (type === 'audio') {
      return moduleData.audios;
    } else if (type === 'image') {
      return moduleData.images.map(function (i) {
        return {
          fileName: i.fileName,
          name: i.name,
          duration: parseInt(moduleData.duration)
        };
      });
    } else {
      throw new Error("Module Type " + type + " not supported");
    }
  };
  /**
   * Parses the replies for a particular question
   *
   * @param {ModuleRepliesSummary} replies
   * @param {object} question
   */


  AnalysisAccess.prototype.parseNivoReplies = function (replies, question) {
    var questionId = question.questionID;
    var total_answers = replies[questionId].total_replies[0].answers;
    var male_answers = replies[questionId].male_replies[0].answers;
    var female_answers = replies[questionId].female_replies[0].answers;
    var nonbinary_answers = replies[questionId].nonbinary_replies[0].answers;
    var total_data = question.answers.map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: total_answers[answer.name] || 0
      };
    });
    var male_data = question.answers.map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: male_answers[answer.name] || 0
      };
    });
    var female_data = question.answers.map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: female_answers[answer.name] || 0
      };
    });
    var nonbinary_data = question.answers.map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: nonbinary_answers[answer.name] || 0
      };
    });
    return {
      total: total_data,
      male: male_data,
      female: female_data,
      nonbinary: nonbinary_data
    };
  };
  /**
   * Parses the replies for a particular module
   *
   * @param {ModuleRepliesSummary} replies Replies for the module
   * @param {Module} activeModule Module information
   */


  AnalysisAccess.prototype.parseNivoMediaReplies = function (replies, activeModule) {
    var questionId = activeModule.id;
    var total_answers = replies[questionId].total_replies[0].answers;
    var male_answers = replies[questionId].male_replies[0].answers;
    var female_answers = replies[questionId].female_replies[0].answers;
    var nonbinary_answers = replies[questionId].nonbinary_replies[0].answers;
    var filter_key = '';

    if (activeModule.type === "video") {
      filter_key = 'videos';
    } else if (activeModule.type === "audio") {
      filter_key = 'audios';
    } else if (activeModule.type === "image") {
      filter_key = 'images';
    }

    var total_data = activeModule[filter_key].map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: total_answers[answer.fileName] || 0
      };
    });
    var male_data = activeModule[filter_key].map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: male_answers[answer.fileName] || 0
      };
    });
    var female_data = activeModule[filter_key].map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: female_answers[answer.fileName] || 0
      };
    });
    var nonbinary_data = activeModule[filter_key].map(function (answer, key) {
      return {
        id: "" + key,
        answer: answer.name,
        value: nonbinary_answers[answer.fileName] || 0
      };
    });
    return {
      total: total_data,
      male: male_data,
      female: female_data,
      nonbinary: nonbinary_data
    };
  }; // NIVO AUDIENCE DATA PARSING

  /**
   * Parses the week interactions
   *
   * @param {AudienceSummary} input Audience summary
   */


  AnalysisAccess.prototype.parseWeekInteractions = function (input) {
    var keys = Object.keys(input);
    var values = Object.values(input);
    var total = values.reduce(function (a, b) {
      return a + b;
    });
    if (total === 0) return {};
    var weekAggregation = {};
    keys.map(function (v) {
      var day = new Date(v).getUTCDay(); // let w = ''
      // if (day === 1) w = 'Monday'
      // if (day === 2) w = 'Tuesday'
      // if (day === 3) w = 'Wednesday'
      // if (day === 4) w = 'Thursday'
      // if (day === 5) w = 'Friday'
      // if (day === 6) w = 'Saturday'
      // if (day === 0) w = 'Sunday'

      weekAggregation[day] = (weekAggregation[day] || 0) + input[v];
    });

    function item(label, value, total) {
      return {
        id: label,
        label: label,
        value: value || 0,
        percentage: Math.round(value * 100 / total) || 0
      };
    }

    return [item('Monday', weekAggregation[1], total), item('Tuesday', weekAggregation[2], total), item('Wednesday', weekAggregation[3], total), item('Thursday', weekAggregation[4], total), item('Friday', weekAggregation[5], total), item('Saturday', weekAggregation[6], total), item('Sunday', weekAggregation[0], total)];
  };
  /**
   * Parses the top locations
   *
   * @param {AudienceSummary} campaignAudienceSummary Audience summary
   */


  AnalysisAccess.prototype.parseTopLocations = function (campaignAudienceSummary) {
    var cities = campaignAudienceSummary.top_city_locations;
    var n_testers = campaignAudienceSummary.n_testers;
    var keys = Object.keys(cities);
    return keys.map(function (v) {
      return {
        id: v,
        label: v,
        value: cities[v],
        percentage: Math.round(cities[v] * 100 / n_testers)
      };
    });
  };
  /**
   * Parses the last month
   *
   * @param {AudienceSummary} input Audience summary
   */


  AnalysisAccess.prototype.parseLastMonth = function (input, label) {
    if (label === void 0) {
      label = "last Month";
    }

    var keys = Object.keys(input);
    return {
      id: label,
      data: keys.map(function (v) {
        return {
          x: v,
          y: input[v]
        };
      })
    };
  };
  /**
   * Parses the audience gender
   *
   * @param {AudienceSummary} campaignAudienceSummary Audience summary
   */


  AnalysisAccess.prototype.parseAudienceGender = function (campaignAudienceSummary) {
    return [{
      "id": "Male",
      "label": "Male",
      "value": campaignAudienceSummary.population.m_pc
    }, {
      "id": "Female",
      "label": "Female",
      "value": campaignAudienceSummary.population.f_pc
    }, {
      "id": "No binaire",
      "label": "No binaire",
      "value": campaignAudienceSummary.population.nb_pc
    }];
  };
  /**
   * Parses the audience age and gender
   *
   * @param {AudienceSummary} campaignAudienceSummary Audience summary
   */


  AnalysisAccess.prototype.parseAudienceAgeGender = function (campaignAudienceSummary) {
    var n_testers = campaignAudienceSummary.n_testers;
    var ages_percent = campaignAudienceSummary.ages_percent;
    var ages_bins = campaignAudienceSummary.ages_bins;
    var res = ages_bins.map(function (v, i) {
      return {
        id: v[0] + " - " + v[1],
        label: v[0] + " - " + v[1],
        value: Math.round(ages_percent[i] * n_testers / 100),
        percentage: ages_percent[i]
      };
    });
    return res;
  };
  /**
   * Parses the global summary
   *
   * @param {AudienceSummary} campaignAudienceSummary Audience summary
   */


  AnalysisAccess.prototype.parseGlobalSummary = function (campaignAudienceSummary) {
    var f_pc = campaignAudienceSummary.population.f_pc;
    var m_pc = campaignAudienceSummary.population.m_pc;
    var nb_pc = campaignAudienceSummary.population.nb_pc;
    var genre_pcs = [f_pc, m_pc, nb_pc];
    var max = Math.max.apply(Math, genre_pcs);
    var max_id = genre_pcs.indexOf(max);
    var genres = ['Female', 'Male', 'Non-binary'];
    var genre = genres[max_id];
    return {
      interactions: campaignAudienceSummary.n_interaction.start,
      users: campaignAudienceSummary.n_testers,
      location: campaignAudienceSummary.main_city,
      genre: genre + " " + max + "%",
      avgAge: Math.round(campaignAudienceSummary.population.avg_age),
      agePercentageTrack: campaignAudienceSummary.population.age_main_interval.min_age + " - " + campaignAudienceSummary.population.age_main_interval.max_age,
      agePercentage: campaignAudienceSummary.population.age_main_interval.pc + "%"
    };
  };
  /**
   * Returns the module with facial recognition tech metrics
   *
   * @param {string} campaignId Campaign uuid
   * @param {string} moduleId Module uuid
   * @param {number} [breakpoints = 30] The number of points to  return
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleMetricsFR>} the module with facial recognition tech metrics
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.moduleMetricsFR = function (campaignId, moduleId, breakpoints, filmBreakpoints, withLinks, renew) {
    if (breakpoints === void 0) {
      breakpoints = 30;
    }

    if (filmBreakpoints === void 0) {
      filmBreakpoints = 100;
    }

    if (withLinks === void 0) {
      withLinks = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_9;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getModuleMetricsFR(campaignId, moduleId, breakpoints, filmBreakpoints, withLinks)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.moduleMetricsFR(campaignId, moduleId, breakpoints, filmBreakpoints, withLinks, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_9 = _a.sent();
            throw error_9;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the module with choose tech metrics
   *
   * @param {string} campaignId Campaign uuid
   * @param {string} moduleId Module uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleMetricsChoose>} The module with choose tech metrics
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.moduleMetricsChoose = function (campaignId, moduleId, withLinks, renew) {
    if (withLinks === void 0) {
      withLinks = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_10;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getModuleMetricsChoose(campaignId, moduleId, withLinks)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.moduleMetricsChoose(campaignId, moduleId, withLinks, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_10 = _a.sent();
            throw error_10;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the test audience global summary
   *
   * @param {string} campaignId Test uuid
   * @param {boolean} [withLinksGlobalSummary = false] If true will return the links global audience
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<AudienceGlobalSummary>} The test audience global summary
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.audienceGlobalSummary = function (campaignId, withLinksGlobalSummary, renew) {
    if (withLinksGlobalSummary === void 0) {
      withLinksGlobalSummary = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_11;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getAudienceGlobalSummary(campaignId, withLinksGlobalSummary)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.audienceGlobalSummary(campaignId, withLinksGlobalSummary, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_11 = _a.sent();
            throw error_11;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   *
   * This function returns the emotional engagement sorted in bins
   *
   * @param {string} campaignId The campaign id
   * @param {string} moduleId The module id
   * @param {string} [stimulusId = ""] The stimulus id. If it is empty, the function will return all the stimuli.
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns An array which each element has the stimulusId, the fileName and the bins information with the number of people and the percentage.
   */


  AnalysisAccess.prototype.getEmotionalEngagementHistogram = function (campaignId, moduleId, stimulusId, renew) {
    if (stimulusId === void 0) {
      stimulusId = "";
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_12;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getEmotionalEngagementHistogram(campaignId, moduleId, stimulusId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getEmotionalEngagementHistogram(campaignId, moduleId, stimulusId, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new Error(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_12 = _a.sent();
            throw error_12;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns the full campaign metrics
   *
   * @param {string} campaignId Campaign uuid
   * @param {boolean} [idDemo = false] If true return demo metrics for all modules
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<ModuleMetricsChoose>} The module with choose tech metrics
   *
   * @throws {NoAnalysisData} When there is no information available
   * @throws {PermissionError} Auth token not valid
   */


  AnalysisAccess.prototype.campaignMetrics = function (campaignId, isDemo, renew) {
    if (isDemo === void 0) {
      isDemo = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, summary, summary, e, error_13;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.campaignMetrics(campaignId, isDemo)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.campaignMetrics(campaignId, isDemo, false)];

          case 5:
            summary = _a.sent();
            return [2
            /*return*/
            , summary];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.NoAnalysisData(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_13 = _a.sent();
            throw error_13;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return AnalysisAccess;
}();

;
exports.default = AnalysisAccess;